import {UserData} from "../generated/user_pb";

export function tryParseUserDataFromLocalStorage(silent = false): UserData | null {
    const userString = localStorage.getItem('user');
    if (!userString) return null;

    try {
        return UserData.deserializeBinary(Uint8Array.from(atob(userString), c => c.codePointAt(0)!));
    } catch (err) {
        if (!silent) console.error('Failed to parse user from localStorage:', err);
        localStorage.removeItem('user');
        return null;
    }
}
